export default "__VITE_ASSET__DHNZxvm9__"